import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress, Modal, TextField } from "@mui/material";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setDevice } from "../redux/slices/deviceSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  paddingTop: 1,
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 300,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldContainer: {
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
    paddingTop: "1rem",
  },
  label: {
    fontWeight: "bold",
    marginRight: "16px",
    width: "100px",
  },
  submitButton: {
    textTransform: "none",
    marginLeft: "70%",
  },
  label: {
    fontWeight: "bold",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "4%",
    marginTop: "2%",
  },
}));

const SingleLinkModal = ({ open, id, onClose }) => {
  const [requestData, setRequestData] = useState({
    id: id,
    meetinglinkid: "",
    linktype: "",
    emms: "",
  });
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);
  const meetingData = useSelector((state) => state.allmeetingspaces);
  const meetingLinkOptions = meetingData.allmeetingspaces;
  const emmsheaders = useSelector((state) => state.emmsheader);
  const emmsList = useSelector((state) => state.emms);
  const emmsOptions = emmsList.emms;
  const curremms=useSelector((state)=>state.curremms)
  const [selectedOption, setSelectedOption] = useState(null);
 
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);

  const oldDeviceData = useSelector((state) => state.device);
  const devices = oldDeviceData.device;
  const dispatch = useDispatch();
 
  useEffect(() => {
    const initialValue = curremms?.curremm?.id;
    setSelectedOption(initialValue);
    const filteredDevices = devices?.filter((device) =>
      id?.includes(device.id)
    );
    setTableData(filteredDevices);
    handleMeetingData();
  }, [devices, id, selectedOption]);

  const handleMeetingData = () => {
    const requestBody = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setMeetingSpaces(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRequestData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "emms") {
      setSelectedOption(value);
    }
    let selectedEmms = emmsList?.emms?.find((element) => element.id === value);

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      handleMeetingData();
    }
  };

  const handleSubmit = () => {
    
    const requestBody = [
      { id: requestData.id, meetinglinkid: requestData.meetinglinkid },
    ];
    axios
      .post(api + "/device/link", requestBody, headers)
      .then((response) => {
        
        const editedDevice = response.data[0];
        const index = oldDeviceData.device.findIndex(
          (device) => device.id === editedDevice.id
        );

        if (index !== -1) {
          const updatedDeviceData = [...oldDeviceData.device];
          updatedDeviceData[index] = editedDevice;
          dispatch(setDevice(updatedDeviceData));
        } else {
          const updatedDeviceData = [...oldDeviceData.device, editedDevice];
          dispatch(setDevice(updatedDeviceData));
        }

        onClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <>
      {" "}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <h4 style={{ fontWeight: "100" }}>
              Linking single Elhi to Meeting Room{" "}
            </h4>
          </div>
          <br />
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <div>
                <div>
                  {getLabelWithAsterisk("Devices Info:", true)}
                  {tableData?.length > 0 && (
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Serial</TableCell>
                            <TableCell>IP</TableCell>
                            <TableCell>Port</TableCell>
                            <TableCell>Type</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableData.map((row) => (
                            <TableRow key={row.id}>
                              <TableCell>{row.serial}</TableCell>
                              <TableCell>{row.ipAddress}</TableCell>
                              <TableCell>{row.portNumber}</TableCell>
                              <TableCell>{row.type}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Link Type:", true)}
                  <FormControl style={{ width: "28.5ch" }} size="small">
                    <InputLabel id="linktype-label">Link Type</InputLabel>
                    <Select
                      labelId="linktype-label"
                      id="linktype"
                      name="linktype"
                      value={requestData.linktype}
                      onChange={handleChange}
                    >
                      <MenuItem value="MeetingRoom">Meeting Room</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.fieldContainer}>
                  {requestData.linktype === "MeetingRoom" && (
                    <>
                      {getLabelWithAsterisk("EMMS Service:", true)}
                      <FormControl
                        style={{ width: "28.5ch" }}
                        size="small"
                        fullWidth
                      >
                        <InputLabel id="service-label">EMMS Service</InputLabel>
                        <Select
                          labelId="service-label"
                          id="emms"
                          name="emms"
                          value={requestData.emms}
                          onChange={handleChange}
                        >
                          {emmsOptions?.map((emms) => (
                            <MenuItem key={emms.id} value={emms.id}>
                              {emms.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div>
                        {" "}
                        <div className={classes.fieldContainer}>
                          {getLabelWithAsterisk("Meeting Link ID:", true)}
                          <FormControl
                            style={{ width: "28.5ch" }}
                            size="small"
                            fullWidth
                          >
                            <InputLabel>Meeting Link ID</InputLabel>
                            <Select
                              name="meetinglinkid"
                              value={requestData.meetinglinkid}
                              onChange={handleChange}
                            >
                              {meetingLinkOptions?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div>
                <div className={classes.fieldContainer}></div>
              </div>

              <div className={classes.fieldContainer}></div>
            </div>

            <div className={classes.buttonContainer}>
              <Button variant="outlined" color="error" onClick={onClose}>
                Cancel
              </Button>
              <Button variant="outlined" onClick={handleSubmit} color="primary">
                Link
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default SingleLinkModal;
